import EnumValueProvider from "../../providers/EnumValueProvider.js";

class PerformanceComparisonBase{
    constructor(typeEnum, paramsEnum, name) {
        if (typeof(typeEnum) === 'undefined'){
            throw new TypeError('typeEnum must be passed as an object, for example BaseballPitchType');
        }

        this.typeEnum = typeEnum;

        if (typeof(paramsEnum) === 'undefined'){
            throw new TypeError('paramsEnum must be passed as an object, for example PitchData');
        }

        this.paramsEnum = paramsEnum;
        this.dataPerType = {};
        this.name = name;
    }

    set(type, parameter, avg, max, stdev, mean, min) {
        if (!EnumValueProvider.getValue(parameter, this.paramsEnum)){
            throw new Error('Unable to match provided parameter to paramsEnum');
        }

        if (this.typeEnum) {
            if (!EnumValueProvider.getValue(type, this.typeEnum)){
                throw new Error('Unable to match provided type to typeEnum');
            }
        }

        if (!this.dataPerType.hasOwnProperty(type)){
            this.dataPerType[type] = {};
        }

        this.dataPerType[type][parameter] = {
            avg, max, stdev, mean, min
        };

        return true;
    }

    get(type, parameter){
        if (!this.hasType(type)){
            throw new Error(`provided type "${type}" is not available`);
        }

        const typeData = this.dataPerType[type];

        if (!typeData.hasOwnProperty(parameter)){
            throw new Error(`provided type "${type}" does not contain data for parameter "${parameter}"`);
        }

        return Object.assign({}, typeData[parameter]);
    }

    getStat(type, parameter, statType){
        if (!this.hasType(type)){
            throw new Error(`provided type "${type}" is not available`);
        }

        const typeData = this.dataPerType[type];

        if (!typeData.hasOwnProperty(parameter)){
            throw new Error(`provided type "${type}" does not contain data for parameter "${parameter}"`);
        }

        if (!typeData[parameter].hasOwnProperty(statType)){
            throw new Error(`provided type "${type}" does not contain stat "${statType}" data for parameter "${parameter}"`);
        }

        if (typeof(typeData[parameter][statType]) !== 'number'){
            throw new Error(`provided type "${type}" does not contain valid value of stat "${statType}" for parameter "${parameter}"`);
        }

        return typeData[parameter][statType];
    }

    has(type, parameter){
        return this.hasType(type) && this.dataPerType[type].hasOwnProperty(parameter);
    }

    hasStat(type, parameter, statType){
        return  this.has(type, parameter)
                && this.dataPerType[type][parameter].hasOwnProperty(statType)
                && typeof(this.dataPerType[type][parameter][statType]) === 'number';
    }

    hasType(type){
        return this.dataPerType.hasOwnProperty(type) && this.dataPerType[type] !== null;
    }
}

export default PerformanceComparisonBase;